import React, { Component } from 'react'
import SignIn from './Page/signin';
import { connect } from 'react-redux';
import authAction from '../redux/auth/actions';
import { Authenticator } from 'aws-amplify-react';
import { notification } from '../components';
import Notification from "./Widgets/Notification";

const { login } = authAction;

class AuthWrapper extends Component {  
  handleAuthStateChange = (state, authData) => {    
    if (state === 'signedIn') {
      const { login } = this.props;
      let token = null;
      if(authData.authenticationFlowType && authData.authenticationFlowType === "USER_SRP_AUTH") {
        token = authData.signInUserSession.idToken.jwtToken; 
      } else {
        const userInfo = JSON.parse(localStorage.getItem('aws-amplify-cachefederatedInfo')).data;
        token = userInfo.token;        
      }                        
      login(token);
      const redirectPath = ( this.props.location.state && this.props.location.state.from && this.props.location.state.from.pathname ) || '/app';
      this.props.history.push(redirectPath);
    }
  }

  errorRenderer = (err) => {
    notification("error", err);
  }
  render() {   
    const style = {
      container: {
        paddingLeft:0,
        paddingRight: 0
      }
    }
    return (
      <Authenticator 
        hideDefault={true} 
        onStateChange={this.handleAuthStateChange} 
        errorRenderer={this.errorRenderer}
        theme={style}>
        <Notification notShow>
        <SignIn {...this.props}/>
        </Notification>
      </Authenticator>
    )
  }  
} 

export default connect(null, {login})(AuthWrapper);